export class ContractsConfiguration {
    constructor(private container: JQuery) {
        const baseUrl = container.attr('data-api-root-prefix');
    }
}
